import { render, staticRenderFns } from "./PTOPolicyCard.vue?vue&type=template&id=a188faac&scoped=true&"
import script from "./PTOPolicyCard.vue?vue&type=script&lang=ts&"
export * from "./PTOPolicyCard.vue?vue&type=script&lang=ts&"
import style0 from "./PTOPolicyCard.vue?vue&type=style&index=0&id=a188faac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a188faac",
  null
  
)

export default component.exports